













 


























const node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isUnvote"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reflectionGroupId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "isUnvote",
    "variableName": "isUnvote"
  },
  {
    "kind": "Variable",
    "name": "reflectionGroupId",
    "variableName": "reflectionGroupId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "StandardMutationError",
  "kind": "LinkedField",
  "name": "error",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesRemaining",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerVoteCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voteCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  (v4/*: any*/),
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VoteForReflectionGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VoteForReflectionGroupPayload",
        "kind": "LinkedField",
        "name": "voteForReflectionGroup",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RetrospectiveMeeting",
            "kind": "LinkedField",
            "name": "meeting",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetrospectiveMeetingMember",
            "kind": "LinkedField",
            "name": "meetingMember",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetroReflectionGroup",
            "kind": "LinkedField",
            "name": "reflectionGroup",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VoteForReflectionGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VoteForReflectionGroupPayload",
        "kind": "LinkedField",
        "name": "voteForReflectionGroup",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RetrospectiveMeeting",
            "kind": "LinkedField",
            "name": "meeting",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetrospectiveMeetingMember",
            "kind": "LinkedField",
            "name": "meetingMember",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetroReflectionGroup",
            "kind": "LinkedField",
            "name": "reflectionGroup",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "m_k8VSceNug7nWlEcXGzge0g",
    "metadata": {},
    "name": "VoteForReflectionGroupMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "673bfd1833894c6e11db35c37429009d";

export default node;
